import SendIcon from '@material-ui/icons/Send';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  sendButton: {
    backgroundColor: 'green',
    color: 'white'
  }
}));

const XHRDevTools = () => {
  const classes = useStyles();

  
  const sendXhr = () => {
    let domain = "https://api.quinnandmurray.com";
    let path = "/api/exercise/devtools"

    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      domain = "http://localhost:9999";
    }

    const url = domain + path;
    fetch(url);
  }


  return (
    <div style={{ textAlign: 'left' }}>
      <h1>Browser DevTools: Network</h1>
      <p>The button below sends an HTTP GET request to a domain called api.quinnandmurray.com every time you click it.</p>
      <p>Using your browser dev tools, inspect the HTTP Request that is sent, and paste the response in the box on the right.</p>
      <Button variant="contained" className={classes.sendButton} startIcon={<SendIcon />} onClick={() => { sendXhr() }}>Send</Button>
    </div>
  )

}

export default XHRDevTools;